import { Component, ChangeDetectorRef, ViewChild, Input, SimpleChanges } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Content, LoadingController, Navbar } from 'ionic-angular';

import { Area } from '../../models/area';
import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { AreaProvider } from '../../providers/area/area';
import { BrComDao } from '../../service/BrComDao';
import { BrComService } from '../../service/BrComService';
import { FotoProvider } from '../../providers/foto/foto'
import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { NavegadorPage } from '../navegador/navegador';
import { Platform } from 'ionic-angular';
import { ServidorProvider } from '../../providers/servidor/servidor';


@Component({
  selector: 'page-conversa-area',
  templateUrl: 'conversa-area.html',
})
export class ConversaAreaPage {

  @ViewChild(Content) content: Content;
  @ViewChild(Navbar) navBar: Navbar;
  @Input() area: Area;
  private empresa: any;
  public mensagemFiltro: Mensagem;
  public placeHolder: string;
  public isUsuarioAdmin: boolean;
  
  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private brComDAO: BrComDao, 
    private lc: ChangeDetectorRef, 
    private brComService: BrComService, 
    private events: Events,
    private loadingCtrl: LoadingController, 
    private areaProvider: AreaProvider,
    private mensagemProvider: MensagemProvider, 
    private areaLocalProvider: AreaLocalProvider,
    private fotoProvider: FotoProvider,
    private platform: Platform) {
    //this.area = this.navParams.get('area');
    this.empresa = this.brComDAO.getEmpresa();
  }

  ngOnChanges(changes: SimpleChanges) {
    const previousValue = changes.area.previousValue;
    // usuário clicou novamente na area que já está selecionada
    if (previousValue && previousValue.id == this.area.idArea) {
      this.removerMensagemFiltro();
      return;
    }
    //usuário trocou de uma area para outra, é necessário remover os listeners da última area
    if (previousValue) {
      this.processarAreaAnterior(changes.area.previousValue);
    }
    this.brComService.confirmaUsuarioLogado(this.empresa.CodEmpresa, this.empresa.CodUsuario);
    this.notificarMensagemLida();
    // ajusta a tela
    this.events.subscribe(`msg.area.${this.area.idArea}`, () => {
      this.atualizaListaMensagens();
      this.notificarMensagemLida();
    });
    this.isUsuarioAdmin = this.isUsuarioAdminDaArea();
    this.atualizaListaMensagens();
  }

  private processarAreaAnterior(area: Area) {
    this.events.unsubscribe(`msg.area.${this.area.idArea}`);
    this.areaLocalProvider.removerMensagensAcimaDoLimite(this.area.idArea);
    this.removerMensagemFiltro();
  }

  private removerMensagemFiltro(): void {
    this.mensagemFiltro = null;
  }

  ngOnDestroy() {
    this.events.unsubscribe(`msg.area.${this.area.idArea}`);
    this.areaLocalProvider.removerMensagensAcimaDoLimite(this.area.idArea);
  }

  ngOnInit() {
    this.content.resize();
  }

  private notificarMensagemLida(): void {
    if (this.hasMensagensNaoLidas()) {
      this.areaProvider.notificarMensagensLidas(this.empresa.IdUsuario, this.brComService.getIdDevice(), this.area.idArea).subscribe();
    }
  }

  private hasMensagensNaoLidas(): boolean {
    if (!this.area.mensagens) {
      return false;
    }
    const result = this.area.mensagens.find(m => m.origem === "L" && !m.statusMensagemLida)
    if (result) {
      return true;
    }
    return false;
  }

  public responderMensagem(mensagem: Mensagem): void {
    this.mensagemFiltro = mensagem;
    this.atualizaListaMensagens();
  }

  private sairDaConversaPrivada(): void {
    this.removerMensagemFiltro();
    this.atualizaListaMensagens();
  }

  private async atualizaListaMensagens(): Promise<void> {
    this.area.mensagens = this.areaLocalProvider.getArea(this.area.idArea).mensagens || [];
    if (this.isFiltrando()) {
      this.area.mensagens = this.filtrarMensagensPorUsuario(this.area.mensagens, this.mensagemFiltro.idUsuarioOrigem);
    }
    this.atualizarPlaceHolder();
    this.detectarMudancas();
    this.scrollBottom();
    this.areaLocalProvider.marcarMensagensLidas(this.area.idArea, this.empresa.IdUsuario);
  }

  private filtrarMensagensPorUsuario(mensagens: Mensagem[], idUsuario: number): Mensagem[] {
    return mensagens.filter(m => m.idUsuarioOrigem === idUsuario || m.idUsuarioDestino === idUsuario || m.idUsuarioDestino === 0);
  }

  private criarMensagem(textoMensagem: string, idUsuarioDestino): Mensagem {
    const mensagem = this.mensagemProvider.criarMensagemSimples({
      idEnvio: new Date().getTime(),
      idMensagemUsuario: 0,
      mensagem: textoMensagem,
      origem: OrigemMensagem.DIREITA,
      idUsuarioDestino: idUsuarioDestino, 
      idUsuarioOrigem: this.empresa.IdUsuario,
      textoTipoMensagem: '',
      podeSerRespondida: false,
    });
    mensagem.pendente = true;
    return mensagem;
  }  

  private criarMensagemImagemEnvio(idUsuarioDestino: number): Mensagem {
    const mensagem = this.mensagemProvider.criarMensagemImagem({
      idEnvio: new Date().getTime(),
      idMensagemUsuario: 0,
      link: "",
      origem: OrigemMensagem.DIREITA,
      idUsuarioDestino: idUsuarioDestino,
      idUsuarioOrigem: this.empresa.IdUsuario,
      textoTipoMensagem: '',
      podeSerRespondida: false
    })
    mensagem.pendente = true;
    return mensagem;
  }

  private criarMensagemArquivoEnvio(idUsuarioDestino:number, arquivo: ArquivoMensagem): Mensagem {
    const mensagem = this.mensagemProvider.criarMensagemArquivo({
      idEnvio: new Date().getTime(),
      idMensagemUsuario: 0,
      arquivo: arquivo,
      origem: OrigemMensagem.DIREITA,
      idUsuarioDestino: idUsuarioDestino,
      idUsuarioOrigem: this.empresa.IdUsuario,
      textoTipoMensagem: '',
      podeSerRespondida: false
    })
    mensagem.pendente = true;
    return mensagem;
  }

  private detectarMudancas(): void {
      try {
        this.lc.detectChanges();
      } catch (err) {}
  }

  public async enviarMensagem(mensagem: string): Promise<void> {
    if (mensagem.trim() !== "") {
      const idUsuarioDestino = this.isFiltrando() ? this.mensagemFiltro.idUsuarioOrigem : 0;
      const msg = this.criarMensagem(mensagem, idUsuarioDestino);
      this.adicionarNovaMensagem(msg);
      if (this.isFiltrando()) {
        this.enviarMensagemUsuarioFiltro(msg);
      } else {
        this.enviarMensagemArea(msg);
      }
    }
  }

  public enviarImagem(imagem: File): void {
    const idUsuarioDestino = this.isFiltrando() ? this.mensagemFiltro.idUsuarioOrigem : 0;
    const msg = this.criarMensagemImagemEnvio(idUsuarioDestino);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(imagem).then(
      url => {
        msg.link = url;
        this.areaLocalProvider.atualizarMensagem(this.area.idArea, msg);
        if (this.isFiltrando()) {
          this.enviarMensagemImagemUsuarioFiltro(msg);
        } else {
          if (this.isUsuarioAdmin) {
            this.enviarMensagemImagemAdminArea(msg);
          } else {
            this.enviarMensagemImagemUsuarioArea(msg);
          }
        }
      }
    )
  }

  public enviarArquivo(file: File): void {
    const arquivo: ArquivoMensagem = {
      nome: file.name,
      mime: file.type,
      link: ""
    }
    const idUsuarioDestino = this.isFiltrando() ? this.mensagemFiltro.idUsuarioOrigem : 0;
    const msg = this.criarMensagemArquivoEnvio(idUsuarioDestino, arquivo);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(file).then(
      url => {
        msg.arquivo.link = url;
        this.areaLocalProvider.atualizarMensagem(this.area.idArea, msg);
        if (this.isFiltrando()) {
          this.enviarMensagemArquivoUsuarioFiltro(msg)
        } else {
          if (this.isUsuarioAdmin) {
            this.enviarMensagemArquivoAdminArea(msg);
          } else {
            this.enviarMensagemArquivoUsuarioArea(msg);
          }
        }
      }, error => {}
    )
  }

  private adicionarNovaMensagem(msg: Mensagem): void {
    this.area.mensagens.push(msg);
    this.detectarMudancas();
    this.content.scrollToBottom(300);
    this.areaLocalProvider.adicionarNovaMensagem(this.area.idArea, msg);
  }

  private enviarMensagemArea(msg: Mensagem): void {
    if (this.isUsuarioAdmin) {
      this.enviarMensagemAdminArea(msg);
    } else {
      this.enviarMensagemUsuarioArea(msg);
    }
  }

  private atualizarMensagemComFalhaNoEnvio(msg: Mensagem) {
    msg.falhaNoEnvio = true;
    this.areaLocalProvider.atualizarMensagem(this.area.idArea, msg);
    this.content.scrollToBottom(0);
  }

  private enviarMensagemArquivoAdminArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemArquivoAdminArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.arquivo).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
        this.atualizaListaMensagens();
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemArquivoUsuarioArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemArquivoUsuarioArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.arquivo).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
        this.atualizaListaMensagens();
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemArquivoUsuarioFiltro(msg: Mensagem): void {
    const idUsuarioDestino = this.mensagemFiltro.idUsuarioOrigem;
    this.areaProvider.enviarMensagemArquivoResposta(this.empresa.IdUsuario, idUsuarioDestino, this.area.idArea, this.brComService.getIdDevice(), msg.arquivo).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
        this.atualizaListaMensagens();
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemImagemUsuarioArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemImagemUsuarioArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.link).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemImagemUsuarioFiltro(msg: Mensagem): void {
    const idUsuarioDestino = this.mensagemFiltro.idUsuarioOrigem;
    this.areaProvider.enviarMensagemImagemResposta(this.empresa.IdUsuario, idUsuarioDestino, this.area.idArea, this.brComService.getIdDevice(), msg.link).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemImagemAdminArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemImagemAdminArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.link).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemAdminArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemAdminArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.mensagem).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemUsuarioArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemUsuarioArea(this.empresa.IdUsuario, this.area.idArea,  this.brComService.getIdDevice(), msg.mensagem).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemUsuarioFiltro(msg: Mensagem): void {
    const idUsuarioDestino = this.mensagemFiltro.idUsuarioOrigem;
    this.areaProvider.enviarMensagemResposta(this.empresa.IdUsuario, idUsuarioDestino, this.area.idArea,  this.brComService.getIdDevice(), msg.mensagem).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private atualizarPlaceHolder(): void {
    if (!this.isUsuarioAdmin) {
      this.placeHolder = "Mensagem para administrador";
    } else {
      if (this.isFiltrando()) {
        this.placeHolder = "Responder participante";
      } else {
        this.placeHolder = "Mensagem para participantes";
      }
    }
  }

  public scrollBottom() {
    setTimeout(() => {
      try {
        this.content.scrollToBottom();
      } catch (error) {}
    }, 300);
  }

  private isUsuarioAdminDaArea(): boolean {
    if (!this.area.idAdministradores) {
      this.area.idAdministradores = [];
    }
    for (const idAdmin of this.area.idAdministradores) {
      if (this.empresa.IdUsuario === idAdmin) {
        return true;
      }
    };
    return false;
  }

  public abrirLink(link: string) {
    //window.open(link, '_blank');
    this.brComService.abrePaginaComTipoURL(link);
  }

  public async abrirLinkHTML(hashHTML: string): Promise<void> {
    const link = `${ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE}/msg/${hashHTML}.html`;
    this.brComService.abrePaginaComTipoURL(link);
    /*
    const load =  this.loadingCtrl.create({content: "Aguarde ..."});
    await load.present();
    this.navCtrl.push(NavegadorPage, {
      url: link
    });
    load.dismiss();*/
  }

  public getNomeCabecalho(): string {
    if (this.isFiltrando()) {
      return this.mensagemFiltro.nomeUsuario;
    }
    return this.area.nome;
  }

  public getImagemCabecalho(): string {
    if (this.isFiltrando()) {
      return this.getImagemUsuario(this.mensagemFiltro);
    }
    return this.getImagemArea();
  }

  public getImagemArea(): string {
    return this.obterImagemComHash(this.area.hashImagem);
  }

  public getImagemUsuario(mensagem: Mensagem): string {
    return this.obterImagemComHash(mensagem.hashLogotipo);
  }

  private obterImagemComHash(hash: string): string {
    if(hash && hash) {
      return this.fotoProvider.getUrlImagemServidor(hash);
    }
    return "assets/img/usuario.png";
  }

  public isUploadingArquivo(mensagem: Mensagem) {
    return !mensagem.arquivo.link && mensagem.arquivo.link === '';
  }

  public isFiltrando(): boolean {
    if (this.mensagemFiltro) {
      return true;
    }
    return false;
  }

  public abrirLinkArquivo(url: string) {
    if (url && url !== "") {
      window.open(url, '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-area/conversa-area.ts